import React from 'react';

const DealVaultLogo = ({ className = "w-9 h-9", showText = false, textClassName = "" }) => {
  return (
    <div className="flex items-center gap-3">
      {/* DV Logo - D and V merged together */}
      <svg 
        viewBox="0 0 48 48" 
        className={className}
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Background */}
        <rect 
          width="48" 
          height="48" 
          rx="8" 
          className="fill-primary/10"
        />
        
        {/* D shape - left side */}
        <path
          d="M12 10H22C30 10 36 16 36 24C36 32 30 38 22 38H12V10Z"
          className="stroke-primary"
          strokeWidth="3"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        
        {/* V shape - integrated inside */}
        <path
          d="M18 16L24 32L30 16"
          className="stroke-primary"
          strokeWidth="3"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        
        {/* Accent dot */}
        <circle
          cx="24"
          cy="24"
          r="2"
          className="fill-primary"
        />
      </svg>
      
      {showText && (
        <span className={`text-xl font-bold font-heading tracking-tight ${textClassName}`}>
          DealVault
        </span>
      )}
    </div>
  );
};

// Alternative modern geometric logo
export const DealVaultLogoModern = ({ className = "w-9 h-9", showText = false, textClassName = "" }) => {
  return (
    <div className="flex items-center gap-3">
      <svg 
        viewBox="0 0 48 48" 
        className={className}
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Background with gradient effect */}
        <rect 
          width="48" 
          height="48" 
          rx="10" 
          className="fill-primary/10"
        />
        
        {/* D outline forming a vault door */}
        <path
          d="M10 8H28C36.837 8 44 15.163 44 24C44 32.837 36.837 40 28 40H10V8Z"
          className="stroke-primary"
          strokeWidth="2.5"
          fill="none"
        />
        
        {/* Inner D line */}
        <path
          d="M14 14H26C31.523 14 36 18.477 36 24C36 29.523 31.523 34 26 34H14V14Z"
          className="stroke-primary/60"
          strokeWidth="1.5"
          fill="none"
        />
        
        {/* V arrow pointing into vault */}
        <path
          d="M20 18L28 24L20 30"
          className="stroke-primary fill-primary/20"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        
        {/* Keyhole / center accent */}
        <circle
          cx="24"
          cy="24"
          r="3"
          className="fill-primary"
        />
      </svg>
      
      {showText && (
        <span className={`text-xl font-bold font-heading tracking-tight ${textClassName}`}>
          DealVault
        </span>
      )}
    </div>
  );
};

// Compact DV monogram logo
export const DealVaultLogoCompact = ({ className = "w-9 h-9", showText = false, textClassName = "" }) => {
  return (
    <div className="flex items-center gap-3">
      <svg 
        viewBox="0 0 48 48" 
        className={className}
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Background */}
        <rect 
          width="48" 
          height="48" 
          rx="8" 
          className="fill-primary/10"
          stroke="currentColor"
          strokeWidth="1"
          strokeOpacity="0.2"
        />
        
        {/* D letter - bold */}
        <path
          d="M8 10H18C26 10 32 16 32 24C32 32 26 38 18 38H8V10Z"
          className="fill-primary"
        />
        
        {/* V letter - overlapping */}
        <path
          d="M22 10L32 38H40L30 10H22Z"
          className="fill-primary/80"
        />
        
        {/* V right side */}
        <path
          d="M30 10L40 38H40L40 10H30Z"
          className="fill-primary/60"
        />
      </svg>
      
      {showText && (
        <span className={`text-xl font-bold font-heading tracking-tight ${textClassName}`}>
          DealVault
        </span>
      )}
    </div>
  );
};

// Shield/Vault style logo
export const DealVaultLogoShield = ({ className = "w-9 h-9", showText = false, textClassName = "" }) => {
  return (
    <div className="flex items-center gap-3">
      <svg 
        viewBox="0 0 48 48" 
        className={className}
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Shield shape background */}
        <path
          d="M24 4L42 10V22C42 34 34 42 24 46C14 42 6 34 6 22V10L24 4Z"
          className="fill-primary/10 stroke-primary"
          strokeWidth="2"
        />
        
        {/* D shape */}
        <path
          d="M14 14H22C28 14 32 18 32 24C32 30 28 34 22 34H14V14Z"
          className="stroke-primary"
          strokeWidth="2.5"
          fill="none"
        />
        
        {/* V inside */}
        <path
          d="M18 18L24 30L30 18"
          className="stroke-primary"
          strokeWidth="2.5"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      
      {showText && (
        <span className={`text-xl font-bold font-heading tracking-tight ${textClassName}`}>
          DealVault
        </span>
      )}
    </div>
  );
};

export default DealVaultLogo;
